import { DeprecatedCustomDownIcon as CustomDown } from '@lokalise/louis';
import { type FC, type ReactNode, useState } from 'react';
import { useUIDSeed } from 'react-uid';

import { Container, Content, Header, IconWrapper, Title } from './styles';

export interface AccordionProps {
    title: string | ReactNode;
    onToggle?: (opened: boolean) => void;
    initiallyExpanded?: boolean;
    noBorder?: boolean;
    iconPosition?: 'right' | 'left';
    children: ReactNode;
}

const Accordion: FC<AccordionProps> = ({
    children,
    title,
    onToggle,
    initiallyExpanded = false,
    noBorder = false,
    iconPosition = 'right',
}) => {
    const uidSeed = useUIDSeed();
    const id = uidSeed('accordionContent');
    const [expanded, setExpanded] = useState(initiallyExpanded);

    const onExpandHandler = () => {
        setExpanded(!expanded);
        if (onToggle) {
            onToggle(!expanded);
        }
    };

    return (
        <Container $noBorder={noBorder}>
            <Header onClick={onExpandHandler} aria-expanded={expanded} aria-controls={id} $iconPosition={iconPosition}>
                {iconPosition === 'left' ? (
                    <>
                        <IconWrapper $expanded={expanded}>
                            <CustomDown size="16px" />
                        </IconWrapper>
                        <Title>{title}</Title>
                    </>
                ) : (
                    <>
                        <Title>{title}</Title>
                        <IconWrapper $expanded={expanded}>
                            <CustomDown size="16px" />
                        </IconWrapper>
                    </>
                )}
            </Header>
            <Content id={id} $expanded={expanded}>
                {children}
            </Content>
        </Container>
    );
};

export default Accordion;
